// Primitive (upload) image node is deprecated: media uploads now go through the
// unified `upload` node. This file is kept only so existing imports keep working
// and any legacy/primitive image node renders the Transform UI instead.
export { ImageTransform as ImagePrimitive } from './transform';
